export default {
  'password': 'Vui lòng nhập mật khẩu',
  'passwordError': 'Mật khẩu có 8-20 chữ số, chỉ hỗ trợ 3 kết hợp chữ hoa chữ thường, số và ký hiệu trở lên',
  'passwordAgain': 'Vui lòng nhập lại mật khẩu',
  'passwordNotSame': 'Nhập khẩu đã nhập không tương thích, vui lòng nhập lại. ',
  'requiredVerifyCode': 'Vui lòng nhập mã xác minh',
  'verifyCode': 'Lỗi CAPTCHA'
}
